import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    isLoading: true,
    isStarted: false,
    isResults: false,
    backend: null,
    summary: [],
    currentStep: 0,
    currentQuestion: null,
    stepPaths: [],
    stepOffers: []
  },
  mutations: {
    SET_IS_LOADING(state, value) {
      state.isLoading = value
    },
    SET_BACKEND(state, value) {
      state.backend = value
    },
    SET_STARTED(state, value ){
      state.isStarted = value
    },
    SET_CURRENT_QUESTION(state, value) {
      state.currentQuestion = value
    },
    SET_CURRENT_STEP(state, value) {
      state.currentStep = value
    },
    NEXT_STEP(state) {
      state.currentStep += 1
    },
    GOTO_RESULTS(state) {
      state.isResults = true
    },
    SET_IS_RESULTS(state, value) {
      state.isResults = value
    },
    SET_SUMMARY(state, value) {
      state.summary = value
    },
    ADD_SUMMARY(state, value) {
      state.summary.push(value)
    },
    ADD_OFFERS(state, value) {
      state.offers.push(value)
    },
    ADD_STEP_PATHS(state, value) {
      state.stepPaths[state.currentStep] = value
    },
    SET_STEP_PATHS(state, value) {
      state.stepPaths = value
    },
    ADD_STEP_OFFERS(state, value) {
      if(!state.stepOffers[state.currentStep]) {
        state.stepOffers[state.currentStep] = []
      }
      state.stepOffers[state.currentStep].push(value)
    },
    SET_STEP_OFFERS(state, value) {
      state.stepOffers = value
    }
  },
  actions: {
    async fetchData({ commit }) {
      commit('SET_IS_LOADING', true)
      try {
        let data = {}
        if (process.env.NODE_ENV === 'production') {
          // Local file (PROD)
          const req = await axios.get('/assets/data/backend.json')
          data = req.data
        } else {
          // Strapi (DEBUG)
          const configResp = await axios.get('http://localhost:1337/config')
          data.config = configResp.data
          const pathsResp = await axios.get('http://localhost:1337/paths')
          data.paths = pathsResp.data
          const questionsResp = await axios.get(`http://localhost:1337/questions`)
          data.questions = questionsResp.data
          const offersResp = await axios.get(`http://localhost:1337/offers`)
          data.offers = offersResp.data
        }
        commit('SET_BACKEND', data)
        const firstQuestion = data.questions.filter(question => question.id === data.config.start_question.id)[0]
        commit('SET_CURRENT_QUESTION', firstQuestion)
        commit('SET_SUMMARY', [firstQuestion])
        commit('ADD_STEP_PATHS', data.paths)
      } catch(err) {
        console.error(err)
      }
      commit('SET_IS_LOADING', false)
    },
    GOTO_SUMMARY({ commit, state }, index) {
      commit('SET_IS_RESULTS', false)
      commit('SET_CURRENT_STEP', index)
      commit('SET_SUMMARY', state.summary.slice(0, index + 1))
      commit('SET_CURRENT_QUESTION', state.summary[state.summary.length - 1])
      commit('SET_STEP_PATHS', state.stepPaths.slice(0, index + 1))
      commit('SET_STEP_OFFERS', state.stepOffers.slice(0, index))
    },
    GOTO_PREVIOUS({ commit, dispatch, state }, isResults) {
      if (isResults) {
        commit('SET_IS_RESULTS', false)
        commit('SET_CURRENT_QUESTION', state.summary[state.summary.length - 1])
        commit('SET_STEP_OFFERS', state.stepOffers.slice(0, state.stepPaths.length - 1))
      } else {
        commit('SET_CURRENT_STEP', state.currentStep - 1)
        commit('SET_SUMMARY', state.summary.slice(0, state.summary.length - 1))
        commit('SET_CURRENT_QUESTION', state.summary[state.summary.length - 1])
        commit('SET_STEP_PATHS', state.stepPaths.slice(0, state.stepPaths.length - 1))
        commit('SET_STEP_OFFERS', state.stepOffers.slice(0, state.stepPaths.length - 1))
      }
    },
    GOTO_INTRO({ commit, state }) {
      const firstQuestion = state.backend.questions.filter(question => question.id === state.backend.config.start_question.id)[0]
      commit('SET_IS_RESULTS', false)
      commit('SET_CURRENT_STEP', 0)
      commit('SET_CURRENT_QUESTION', firstQuestion)
      commit('SET_SUMMARY', [firstQuestion])
      commit('SET_STEP_PATHS', [])
      commit('SET_STEP_OFFERS', [])
      commit('SET_STARTED', false)
      commit('ADD_STEP_PATHS', state.backend.paths)
    }
  }
})
